import React from 'react';
import { MailOutlined, WhatsAppOutlined, MessageOutlined, TruckOutlined, WalletOutlined, FundOutlined, CheckCircleOutlined, InfoCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';

const SOURCE_ICONS = { mail: MailOutlined, customer: WhatsAppOutlined, internal: MessageOutlined, operations: TruckOutlined, payments: WalletOutlined, sales: FundOutlined };
const STATUS_ICONS = { success: CheckCircleOutlined, info: InfoCircleOutlined, warning: WarningOutlined, error: CloseCircleOutlined };

// Presentation only. Callers retain their key, handlers, rich content and timing.
export function notificationDesign(source = 'general', severity = 'info') {
  const tone = severity === 'error' ? 'error' : SOURCE_ICONS[source] ? source : severity;
  const Icon = severity === 'error' ? CloseCircleOutlined : SOURCE_ICONS[source] || STATUS_ICONS[severity] || InfoCircleOutlined;
  return {
    className: `srm-notification srm-notification--${source} srm-notification-tone--${tone}`,
    icon: <Icon />,
    placement: 'topRight',
    ...(source === 'mail' ? { duration: 0 } : {}),
  };
}
